import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {UserRole} from '../model/Entities/UserRole';

@Injectable()
export class RoleService extends ApiService<User> {

    protected apiUrl = 'api/role';

    protected getObjectType(): any {
        return UserRole;
    }

}



// WEBPACK FOOTER //
// /app/src/services/role.service.ts